import { TrackEventProps } from "core/types";
import { startCase } from "lodash";
import z from "zod";

const CAPITALIZED_REGEX = /^(?:[A-Z][a-z]*\s?)+$/;

export const stringOrNull = z.nullable(z.string());
export const numberOrNull = z.nullable(z.number());

export const pageNameSchema = z
  .string()
  .refine((val) => val === "not defined" || CAPITALIZED_REGEX.test(val), {
    message: "must be 'not defined' or all words capitalized",
  });

export const dateFormatRFC3339 = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[+-]\d{2}:\d{2}$/);

export function generateTrackName<T extends "Button" | "Link" = "Button">({
  id: domId,
  trackEventProps,
  type = "Button" as T,
}: {
  id: string;
  type?: T;
  trackEventProps: TrackEventProps | undefined;
}) {
  const id = trackEventProps?.id ?? domId;
  const trackName = `${startCase(startCase(id).toLowerCase())} ${type} Clicked`;

  return trackName as T extends "Button"
    ? `${string} Button Clicked`
    : `${string} Link Clicked`;
}
